import { Link, useLocation } from 'react-router-dom'
import UserNav from './UserNav'

const NAV_LINKS = [
  { to: '/headhunter', label: 'Dashboard' },
  { to: '/headhunter/jobs', label: 'Jobs' },
  { to: '/headhunter/candidates', label: 'Candidates' },
  { to: '/headhunter/pipeline', label: 'Pipeline' },
]

export default function HeadhunterLayout({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation()

  return (
    <div className="min-h-screen bg-background text-foreground">
      <nav className="bg-surface-low border-b border-border-subtle sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link
            to="/headhunter"
            className="text-base font-bold text-foreground tracking-tight"
          >
            NYMO
          </Link>

          <div className="flex items-center gap-1">
            {NAV_LINKS.map(({ to, label }) => {
              const active = to === '/headhunter' ? pathname === '/headhunter' : pathname.startsWith(to)
              return (
                <Link
                  key={to}
                  to={to}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    active
                      ? 'text-primary bg-primary-light'
                      : 'text-text-muted hover:text-foreground hover:bg-surface-lowest'
                  }`}
                >
                  {label}
                </Link>
              )
            })}
          </div>

          <UserNav />
        </div>
      </nav>
      <main className="max-w-6xl mx-auto px-6 py-8">{children}</main>
    </div>
  )
}
